import cx from 'classnames';
import React from 'react';
import styles from './index.module.scss';

export default class Text extends React.Component<
  React.HTMLAttributes<HTMLSpanElement>
> {
  public render() {
    const { className, ...restProps } = this.props;

    return <span className={cx(styles.text, className)} {...restProps} />;
  }
}
